<template>
	<page enable-flex create-button @create="addHandle">
		<view-list work-type="11" view-id="10011" :search="{placeholder: '搜单据编号'}">
			<template #default="{data, index}">
				<view-doc-card :key="index" type="11" :data="data">
					<!--状态-->
					<template #status>
						<c-state dict="flowOrderStateDic" :value="data.status"></c-state>
					</template>

					<!--紧急程度-->
					<template #emergency_level>
						<c-state dict="orderUrgencyDic" :value="data.emergency_level"></c-state>
					</template>

					<!--报销类型-->
					<template #reimbursement_type>
						<c-state dict="reimbursementTypeDic" :value="data.reimbursement_type"></c-state>
					</template>

					<!--合计金额-->
					<template #total_amount>
						￥{{data.total_amount}}
					</template>
				</view-doc-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		name: 'm_app_expense_reimbursement',
		
		data() {
			return {
			}
		},
		
		methods: {
			addHandle() {
				this.mp.navigateWeb('/finance/reimb/edit')
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>